const houseViewSchema = [{
  developmentImage: null,
  floors: [],
  houseTypeId: null
}]
export default houseViewSchema;
